import { ymdToDmy } from './reportDateParams'

/** Append array as `key[]` for list APIs (Angular `getRequestBody`). */
export function appendBracketArrayParams(
  params: URLSearchParams,
  key: string,
  values: string[],
): void {
  values.forEach((value) => params.append(`${key}[]`, value))
}

export function appendMrgReportListParams(
  qs: URLSearchParams,
  p: {
    page: number
    perPage: number
    sortBy: string
    orderBy: string
    q: string
    company_id: string
    property_id: string
    fromDt: string
    toDt: string
    claimfromDt: string
    claimtoDt: string
    rentalStatus: string[]
  },
): void {
  qs.set('page', String(p.page))
  qs.set('perPage', String(p.perPage))
  qs.set('sortBy', p.sortBy)
  qs.set('orderBy', p.orderBy)
  if (p.q.trim()) qs.set('q', p.q.trim())
  if (p.company_id) qs.set('company_id', p.company_id)
  if (p.property_id) qs.set('property_id', p.property_id)
  const from = p.fromDt ? ymdToDmy(p.fromDt) : ''
  const to = p.toDt ? ymdToDmy(p.toDt) : ''
  if (from) qs.set('fromDt', from)
  if (to) qs.set('toDt', to)
  const claimFrom = p.claimfromDt ? ymdToDmy(p.claimfromDt) : ''
  const claimTo = p.claimtoDt ? ymdToDmy(p.claimtoDt) : ''
  if (claimFrom) qs.set('claimfromDt', claimFrom)
  if (claimTo) qs.set('claimtoDt', claimTo)
  if (p.rentalStatus.length) appendBracketArrayParams(qs, 'rentalStatus', p.rentalStatus)
}

export function appendWeeklyReimbursementsListParams(
  qs: URLSearchParams,
  p: {
    page: number
    perPage: number
    sortBy: string
    orderBy: string
    fromDt: string
    toDt: string
    year: string
    week_filter: string[]
  },
): void {
  qs.set('page', String(p.page))
  qs.set('perPage', String(p.perPage))
  qs.set('sortBy', p.sortBy)
  qs.set('orderBy', p.orderBy)
  if (p.year) qs.set('year', p.year)
  if (p.fromDt) qs.set('fromDt', p.fromDt)
  if (p.toDt) qs.set('toDt', p.toDt)
  if (p.week_filter.length) appendBracketArrayParams(qs, 'week_filter', p.week_filter)
}

export function appendPmcPerformanceListParams(
  qs: URLSearchParams,
  p: {
    page: number
    perPage: number
    sortBy: string
    orderBy: string
    fromDt: string
    toDt: string
    company_id: string
    sales_team: string[]
    report_type: 'red' | 'green'
  },
): void {
  qs.set('page', String(p.page))
  qs.set('perPage', String(p.perPage))
  qs.set('sortBy', p.sortBy)
  qs.set('orderBy', p.orderBy)
  qs.set('report_type', p.report_type)
  if (p.fromDt) qs.set('fromDt', p.fromDt)
  if (p.toDt) qs.set('toDt', p.toDt)
  if (p.company_id) qs.set('company_id', p.company_id)
  if (p.sales_team.length) appendBracketArrayParams(qs, 'sales_team', p.sales_team)
}

export function buildMrgReportExportQueryParams(
  p: Parameters<typeof appendMrgReportListParams>[1],
): URLSearchParams {
  const qs = new URLSearchParams()
  appendMrgReportListParams(qs, p)
  return qs
}
